import { Id } from 'types/definitions'

/**
 * Archival information for a document.
 */
export interface DocumentArchival {
  readonly archivedAt: Date
  readonly archivedBy: Id
}

/**
 * Purge information for a document.
 */
export interface DocumentPurge {
  readonly purgedAt: Date
  readonly purgedBy: Id
}

/**
 * The document is active and retained normally.
 */
export interface ActiveRetention {
  readonly type: 'Active'
}

/**
 * The document has been archived.
 */
export interface ArchivedRetention {
  readonly type: 'Archived'
  readonly archival: DocumentArchival | null
}

/**
 * The document has been purged.
 */
export interface PurgedRetention {
  readonly type: 'Purged'
  readonly archival: DocumentArchival | null
  readonly purge: DocumentPurge | null
}

/**
 * Retention information for a document - whether it's active, archived, or purged.
 */
export type DocumentRetention =
  | ActiveRetention
  | ArchivedRetention
  | PurgedRetention

/**
 * @see {DocumentRetention}
 */
export const DocumentRetention = {
  /**
   * The retention state a document starts its lifecycle in.
   */
  active: { type: 'Active' } satisfies DocumentRetention,
} as const
